import { render } from "./SurveyLocaleList.vue?vue&type=template&id=d39cc0e2"
import script from "./SurveyLocaleList.vue?vue&type=script&lang=js"
export * from "./SurveyLocaleList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__